import { Box, Button, Grid, Typography } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import "./PowerComplaintsTrack.scss";
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from "yup";

const PowercomplaintsTrack = () => {
  const initialValues = {
    // tracking number Initial Values
    iv_tracking_number: '',
  }
  // // Complaint Details States
  // const [complaintDetails, setComplaintDetails] = useState('');
  // const [tiketNo, setTicketNo] = useState()
  // Formik form submission and complaint API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        // // Classification group Validations
        iv_tracking_number: Yup.string().required('Please enter the tracking no.').min(14, "Please enter 14 digit tracking number.").max(14, "Please enter 14 digit tracking number."),
      }),
      onSubmit: (values, action) => {
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "laravel_session=eyJpdiI6IndXbXlCOHp4WFwvaGFxRWljeUdvQnBRPT0iLCJ2YWx1ZSI6InArVFB3YStVek9jcmpIQXhiR2RPdkJVS1wvbWdLWEtSRDlUS1RJazFtUGpNXC9uZ2xWZjVINEFIdXlidU9pYU8rTiIsIm1hYyI6IjY4OWQ2NjZmZDg3NWVkMjA2ZGU2NWQ2ZjIyYmE2N2Q2NzI4MDk5ODkyODY0NzAwMmRjMDIyNDQxMDY3OTA0NjIifQ%3D%3D");
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          headers: myHeaders,
          redirect: 'follow',
        };
        fetch("http://ccms.pitc.com.pk/api/complaints/mobile/" + values.iv_tracking_number, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.COMPLAINT_SEARCH[0].RECORD_FOUND === 'TRUE') {
            }
            else {
            }
          })
          .catch(() => {});
      }
    })
  return (
    <Grid container className='powerComplaintTrack'>
      <Box className='powerComplaintTrackContainer'>
        <Typography variant='h6' className='heading'>
          Complaint Tracking
        </Typography>
        <form className='powerComplaintTrackForm' >
          <Grid container spacing={1}>
            <Grid item xs={4} >
              <Typography className='fieldLabel'>Tracking No.</Typography>
              <TextField
                required
                type='text'
                name="iv_tracking_number"
                value={values.iv_tracking_number}
                onChange={handleChange}
                onBlur={handleBlur}
                id="iv_tracking_number"
                className='textInputField'
              />
              <Box className='from-Error'>
                {errors.iv_tracking_number && touched.iv_tracking_number ? (errors.iv_tracking_number) : null}
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ marginTop: '1%' }}>
            <Button sx={{ width: '35%' }} variant="contained" component="label" type='submit' onClick={handleSubmit} >
              Track
            </Button>
            < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
          </Box>
        </form>
      </Box>
    </Grid >
  );
}
export default PowercomplaintsTrack

